export default {"src":"/_next/static/media/li-bold-color.1aeb3c8b.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};